<template>
  <div>
    <v-navigation-drawer v-model="sidebar" app disable-resize-watcher>
      <v-list-item>
        <v-list-item-title class="text-h6">
          {{ $t('navigation.menu') }}
        </v-list-item-title>
        <v-btn icon @click="sidebar = false">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>
      <v-list dense rounded>
        <v-list-item v-for="item in cta" :key="item.name" :to="item.route">
          <v-list-item-content>{{ item.name }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      :color="isItLanding ? navBarBg : ''"
      :elevate-on-scroll="isItLanding"
      elevation="2"
      height="64"
      class="center-appbar"
    >
      <span class="hidden-sm-and-up">
        <v-app-bar-nav-icon @click="sidebar = !sidebar" />
      </span>
      <div class="appbar-row d-flex align-center justify-center flex-nowrap w-100 px-4">
        <router-link to="/" class="d-flex align-center mr-4">
          <v-img
            alt="Surpluss Logo"
            contain
            :src="isItLanding ? logo : appLogo"
            transition="scale-transition"
            height="40"
            class="app-logo"
          />
        </router-link>
        <v-btn
          v-for="item in cta"
          :key="item.name"
          :to="item.route"
          :text="item.text"
          :outlined="item.outline"
          :class="item.class"
        >
          {{ item.name }}
        </v-btn>
        <v-btn class="primary-btn" @click="logout">
          {{ $t('navigation.logout') }}
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
  import appLogo from '@/assets/logo.svg';
  import appLogoDark from '@/assets/logo-dark.svg';
  import { mapGetters } from 'vuex';
  import { LOGOUT } from '@/store/modules/auth';

  export default {
    name: 'AdminNav',
    data() {
      return {
        appLogo,
        appLogoDark,
        logo: appLogo,
        navBarBg: 'transparent',
        sidebar: false,
        cta: [
          {
            name: 'User Management',
            route: 'users',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Offerings',
            route: 'offerings',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Companies',
            route: 'companies',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Statistics',
            route: 'statistics',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Queries',
            route: 'queries',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Categories',
            route: 'categories',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Donations',
            route: 'donations',
            text: true,
            outline: false,
            class: '',
          },
          {
            name: 'Subscription Plans',
            route: 'subscription-plans',
            text: true,
            outline: false,
            class: '',
          },
        ],
      };
    },
    computed: {
      isItLanding() {
        return this.$route.name === 'landing';
      },
      ...mapGetters({
        isAuthenticated: 'auth/isAuthenticated',
      }),
    },
    mounted() {
      window.onscroll = () => {
        this.changeColor();
      };
      this.logo = this.isItLanding ? this.appLogoDark : this.appLogo;
    },
    methods: {
      changeColor() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          this.navBarBg = 'white';
          if (this.isItLanding) {
            this.logo = appLogo;
          }
        } else {
          this.navBarBg = 'transparent';
          if (this.isItLanding) {
            this.logo = appLogoDark;
          }
        }
      },
      logout() {
        this.$store.dispatch(`auth/${LOGOUT}`);
        this.$router.push('/login');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .register-btn {
    background-color: $srpls-primary !important;
  }
  .app-logo {
    max-height: 40px;
    display: block;
  }
  /* Center the whole row and keep even spacing between all items */
  .appbar-row {
    gap: 16px;
  }
  /* Ensure buttons don't introduce extra side margins that break centering */
  .appbar-row .v-btn {
    margin: 0 !important;
  }
  /* Center the v-app-bar content like in inspector */
  .center-appbar {
    display: flex;
    justify-content: center;
  }
  .center-appbar .v-toolbar__content {
    display: flex;
    justify-content: center;
  }
</style>
